import { useFormContext, useWatch } from "react-hook-form";
import {
  InputFormField,
  CheckboxListFormField,
  GridItem,
  GridContainer,
  FormSection,
  ReferenceDataDomain,
  ReferenceDataCode,
  RecognitionKind,
} from "@duosoftbg/nacid-components";
import React, { useEffect } from "react";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { seRecognitionPurposeThunk } from "../../../../../../store/redux/slice/AppData/seRecognitionPurpose";

const recognitionPurposeFilterMap = {
  [RecognitionKind.CERTIFICATE]: null, // null means allow all
  [RecognitionKind.VERIFICATION_LETTER]: ["ODL", "ALM", "OTH"],
  [RecognitionKind.OFFICIAL_NOTE]: ["AHE", "OTH"],
};

const RecognitionPurposeFormSection = ({ recognitionKind }) => {
  const { getValues } = useFormContext();
  const dispatch = useAppDispatch();

  const thunkStateRecognitionPurpose = useAppSelector((state) => {
    return state.AppData.SeRecognitionPurpose;
  });

  useEffect(() => {
    dispatch(seRecognitionPurposeThunk());
  }, [dispatch]);

  const filterRecognitionPurposes = () => {
    const allowedIds = recognitionPurposeFilterMap[recognitionKind];

    if (!allowedIds) {
      return thunkStateRecognitionPurpose.data || [];
    }

    return (thunkStateRecognitionPurpose.data || []).filter((option) => allowedIds.includes(option.id));
  };

  const filteredOptions = filterRecognitionPurposes();

  return (
    <FormSection label={"t.recognitionPurposes"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem sm={6} md={6}>
          <CheckboxListFormField
            required={true}
            fieldName={"recognitionPurposes"}
            labelCode={"t.recognitionPurposes"}
            checkboxOptions={filteredOptions.map((option) => {
              return { value: option.id, text: option.name, active: option.isActive };
            })}
            valuesAreEqual={(checkboxVal, arrayVal) => checkboxVal === arrayVal.id}
            selectValueTransform={(selected) => {
              return {
                id: selected,
                name: "",
                domain: ReferenceDataDomain.SEC_EDU_RECOGNITION_PURPOSE,
              };
            }}
          />
        </GridItem>
      </GridContainer>
      {getValues().recognitionPurposes.filter((val) => val.id === ReferenceDataCode.OTHER).length > 0 ? (
        <GridContainer>
          <GridItem sm={6} md={6}>
            <InputFormField
              fieldName={"recognitionPurposeOtherDetails"}
              labelCode={"l.recognitionPurposeOtherDetails"}
            />
          </GridItem>
        </GridContainer>
      ) : null}
    </FormSection>
  );
};
export default RecognitionPurposeFormSection;
